import {HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs";

export class DownloadableFile {

    constructor(private response: Observable<HttpResponse<Blob>>) {}

    getFileName(response: HttpResponse<Blob>) {
        let filename: string;
        try {
            const contentDisposition: string = response.headers.get('content-disposition');
            const r = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
            filename = r.exec(contentDisposition)[1];
        }
        catch (e) {
            console.error(e);
            filename = 'myfile.txt'
        }
        return filename
    }

    download(callable) {
        this.response.subscribe({
            next: (response: HttpResponse<Blob>) => {
                let filename: string = this.getFileName(response)
                let binaryData = [];
                binaryData.push(response.body);
                let downloadLink = document.createElement('a');
                downloadLink.href = URL.createObjectURL(new Blob(binaryData, { type: 'blob' }));
                downloadLink.setAttribute('download', filename);
                document.body.appendChild(downloadLink);
                downloadLink.click();
                callable()
            }
        })
    }
}
